import { FC } from 'react'

interface ComingSoonPlaceholderProps {
  title: string
}

// Contenido placeholder compartido por las secciones del sidebar de cuenta
// que todavía no tienen funcionalidad (Mis arrendamientos, Mis documentos,
// Mi perfil, Configuración).
export const ComingSoonPlaceholder: FC<ComingSoonPlaceholderProps> = ({
  title,
}) => (
  <>
    <h2 className="text-2xl font-bold text-gray-900 mb-4">{title}</h2>
    <div className="bg-white border border-olr-grey-2 rounded-lg p-12 text-center text-olr-body">
      Próximamente
    </div>
  </>
)
